import React from "react";
import { Modal } from "react-bootstrap";
import EditProfileForm from "../../../Home/Forms/EditProfileForm";

const EditProfileModal = ({ show, onClose, user, onSubmit, t }) => {
    if (!show || !user) return null;

    return (
        <Modal size="lg" centered backdrop="static" keyboard={false} show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="h5 mb-0">
                        <i className="fad fa-edit text-primary icon ml-2"></i>
                        {t("Pages.UsersControl.action.edit")}:
                        <span className="text-primary mr-1">{user.Name}</span>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="widget widget-category">
                    <div className="widget-body">
                        <EditProfileForm isAdmin={true} user={user} onSubmit={onSubmit} />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default EditProfileModal;
